/**
 * Generates a label from the first and last character of the provided name.
 *
 * @param name - The full name as a string. Defaults to an empty string if not provided.
 * @returns A string containing the first character of the first name and the first character of the last name, both in uppercase.
 * @example
 * ```ts
 * getNameLabel('John Doe'); // Returns 'JD'
 * getNameLabel('John (Doe)'); // Returns 'JD'
 * getNameLabel('John'); // Returns 'J'
 * getNameLabel(''); // Returns ''
 * getNameLabel(); // Returns ''
 * ```
 */
export const getNameLabel = (name: string = '') => {
	if (!name) return '';

	const NON_ALPHABETIC_REGEX = /[^a-zA-Z\s]/g;
	const sanitized = name.replace(NON_ALPHABETIC_REGEX, '').trim();
	const fullName = sanitized.split(' ');
	const firstNameChar = fullName.shift()?.charAt(0) || '';
	const lastNameChar = fullName.pop()?.charAt(0) || '';

	return `${firstNameChar}${lastNameChar}`.toUpperCase();
};
